// extracted by mini-css-extract-plugin
module.exports =  {"content":"Ov6CyVv","disable-padding":"_3UZJUG","disablePadding":"_3UZJUG"};